import gql from 'graphql-tag'
export interface ChangePasswordByTokenInput {
  token: string
  password: string
}

export interface ChangePasswordByToken {
  changePasswordByToken: boolean
}

export default gql`
  mutation ChangePasswordByToken($token: String!, $password: String!) {
    changePasswordByToken(token: $token, password: $password)
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/changePasswordByToken.tsx